import type { Language } from '@cognite/user-profile-components';

// Keep literal value types so downstream hooks can form a union of namespaces.
export const TRANSLATION_NAMESPACES = {
  activity: 'activity',
  asset: 'asset',
  assignment: 'assignment',
  checklist: 'checklist',
  conditions: 'conditions',
  configuration: 'configuration',
  fileUploader: 'FileUploader',
  documents: 'documents',
  errorView: 'ErrorView',
  fileViewer: 'file-viewer',
  infobar: 'infobar',
  mainTopbar: 'main-topbar',
  measurement: 'measurement',
  mediaManager: 'media-manager',
  notification: 'notification',
  observations: 'observations',
  search: 'search',
  sidebar: 'sidebar',
  template: 'template',
  threeD: 'ThreeD',
  timeseries: 'timeseries',
  trends: 'trends',
  user: 'user',
  userOnboarding: 'user-onboarding',
  landingPage: 'LandingPage',
} as const;

export const DEFAULT_LANGUAGE: Language = {
  code: 'en',
  label: 'English',
};

export const languageLabels: { [key in Language['code']]?: string } = {
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  nl: 'Nederlands',
  nb: 'Norsk',
  pt: 'Português',
  sv: 'Svenska',
  ko: '한국어',
  lv: 'Latviešu',
  zh: '中文',
  ja: '日本語',
};
